"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Input = _interopRequireDefault(require("@material-ui/core/Input"));

var _commonField = _interopRequireDefault(require("./common-field"));

var _attach = _interopRequireDefault(require("../attach"));

var _displayValueTypography = _interopRequireDefault(require("./display-value-typography"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TextField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(TextField, _React$PureComponent);

  var _super = _createSuper(TextField);

  function TextField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TextField);
    _this = _super.call(this, props); // Create a custom TextMask component. This is done once in the constructor so that it is not
    // done in each call to render()

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (event) {
      var component = _this.props.component;
      var value = component.fromUIValue(event.target.value);
      component.setValue(value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBlur", function () {
      _this.props.component.setTouched(true);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyUp", function (event) {
      // If the user presses enter on the field then mark as touched. This is necessary for when the
      // user is using the keyboard to enter data and there is an error on the last field that needs
      // to be reported when the user presses enter.
      if (event.keyCode === 13) {
        _this.props.component.setTouched(true);
      }
    });

    _this.TextMaskCustom = function (props) {
      var inputRef = props.inputRef,
          other = (0, _objectWithoutProperties2.default)(props, ["inputRef"]);
      var mask = _this.props.mask;
      return /*#__PURE__*/_react.default.createElement(_reactTextMask.default, (0, _extends2.default)({}, other, {
        ref: function ref(_ref) {
          inputRef(_ref ? _ref.inputElement : null);
        },
        mask: mask
      }));
    };

    return _this;
  }

  (0, _createClass2.default)(TextField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          err = _this$props.err,
          maxLength = _this$props.maxLength,
          touched = _this$props.touched,
          disabled = _this$props.disabled,
          component = _this$props.component,
          fullWidth = _this$props.fullWidth,
          type = _this$props.type,
          editable = _this$props.editable,
          accessEditable = _this$props.accessEditable,
          multiline = _this$props.multiline,
          rows = _this$props.rows,
          rowsMax = _this$props.rowsMax,
          useDisplayValue = _this$props.useDisplayValue,
          mask = _this$props.mask,
          displayValue = _this$props.displayValue;
      var dis = accessEditable === false || disabled;
      var fld = null;

      if (editable && !useDisplayValue) {
        var optional = {};

        if (mask) {
          optional.inputComponent = this.TextMaskCustom;
        }

        var uiValue = component.getUIValue();
        fld = /*#__PURE__*/_react.default.createElement(_Input.default, (0, _extends2.default)({
          id: component.getUniqueId(),
          error: touched && err ? true : false,
          inputProps: {
            maxLength: maxLength
          },
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          onKeyUp: this.handleKeyUp,
          value: uiValue ? uiValue : '',
          disabled: dis,
          fullWidth: fullWidth,
          type: type,
          multiline: multiline,
          rows: rows,
          rowsMax: rowsMax
        }, optional));
      } else {
        fld = /*#__PURE__*/_react.default.createElement(_displayValueTypography.default, {
          id: component.getUniqueId() // We need to specify the aria-label so that this element is linked to the target field
          // label
          ,
          "aria-label": component.get('label')
        }, displayValue ? displayValue : component.getDisplayValue());
      }

      return /*#__PURE__*/_react.default.createElement(_commonField.default, {
        component: component
      }, fld);
    }
  }]);
  return TextField;
}(_react.default.PureComponent);

var _default = (0, _attach.default)(['value', 'err', 'maxLength', 'touched', 'disabled', 'fullWidth', 'type', 'editable', 'multiline', 'rows', 'rowsMax', 'useDisplayValue', 'mask', 'unmask'])(TextField);

exports.default = _default;